import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
    selector: '[autofocus]'
})
export class AutofocusDirective {
    constructor(private host: ElementRef) { }

    @Input() autofocus?: string | number;

    ngAfterViewInit() {
        let timeout: number = (this.autofocus === 'string'
            ? parseFloat(this.autofocus)
            : <number | undefined>this.autofocus) || 100;
        setTimeout(() => {
            this.host.nativeElement.focus();
        }, timeout);
    }
}